import { Controller } from '@hotwired/stimulus'

const DEFAULT_OPEN_CLASS = 'beachy-actions-overflow-open'

// The ⋯ menu in a page header, and the labelled "More ▾" dropdown. The collapsing
// actions are one set of nodes that CSS renders inline above the 1240 tier and as
// menu rows below it, so this only ever toggles the open class.
// Override the class with data-beachy-overflow-open-class on the controller element.
export default class extends Controller {
  static targets = ['menu', 'button']
  static classes = ['open']

  connect() {
    this.dismiss = this.dismiss.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    this.stopListening()
  }

  get menuOpenClass() {
    return this.hasOpenClass ? this.openClass : DEFAULT_OPEN_CLASS
  }

  toggle() {
    if (this.menuTarget.classList.contains(this.menuOpenClass)) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.add(this.menuOpenClass)
    this.buttonTarget.setAttribute('aria-expanded', 'true')
    document.addEventListener('mousedown', this.dismiss)
    document.addEventListener('keydown', this.onKeydown)
  }

  close() {
    this.menuTarget.classList.remove(this.menuOpenClass)
    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.stopListening()
  }

  stopListening() {
    document.removeEventListener('mousedown', this.dismiss)
    document.removeEventListener('keydown', this.onKeydown)
  }

  dismiss(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close()
  }
}
